export default __webpack_public_path__ + "static/LeituraTwo-Medium-b0c4900877758508c64a44eea369c938.woff2";